import { Controller } from "@hotwired/stimulus"

// Envía el formulario padre (incluye valor vacío), p. ej. filtros GET con «todas las opciones».
export default class extends Controller {
  submit() {
    const form = this.element.form
    if (!form) return

    form.requestSubmit()
  }
}
